/*
 * hamburger
 *
 * runs the functionality of clicking the hamburger icon in the top nav
 */

const selector = '.js-hamburger';
const activeClass = 'is-active';
const bodyActiveClass = 'h-scroll-lock nav-active';
const headerActiveClass = 'o-header-1--hamburger-active';
const navMenu = '.js-slide-out';
const navMenuActiveClass = 'm-slide-out--active';
const headerSearchButton = 'o-header-1__search-button';
const searchBar = 'm-search-bar';
const plusToggle = '.js-nav-drop';

let isActive;
const tabbableElements = $(
    `${navMenu} a[href]:visible:not([disabled]), 
     ${navMenu} button:visible:not([disabled]),
     ${navMenu} input:visible:not([disabled]), 
     ${navMenu} select:visible:not([disabled]), 
     ${navMenu} textarea:visible:not([disabled]), 
     ${navMenu} [tabindex]:not([tabindex="-1"]):visible:not([disabled])`,
);

export function hamburger() {
    $(selector).click((e) => {
        e.preventDefault();
        $(selector).toggleClass(activeClass);

        // Ensuring body cannot be scrolled up and down when the mobile nav is shown
        $('.js-body').toggleClass(bodyActiveClass);
        $('.js-header').toggleClass(headerActiveClass);

        // Makes slide-out appear
        $(navMenu).toggleClass(navMenuActiveClass);

        // Set or remove tabindex based on the presence of 'navMenuActiveClass'
        if ($(navMenu).hasClass(navMenuActiveClass)) {
            $(navMenu).find(plusToggle).attr('tabindex', 0); // Add tabindex
        } else {
            $(navMenu).find(plusToggle).removeAttr('tabindex');
        }

        $(`.${headerSearchButton}`).toggleClass(`${headerSearchButton}--anim`);

        if ($(`.${searchBar}`).hasClass(`${searchBar}--active`)) {
            $(selector).parent().siblings(headerSearchButton).trigger('click');
        }
    });

    // Ensuring slideout nav menu is next element focused after hamburger toggle button
    $(selector).keydown(function (e) {
        if (e.key === 'Tab') {
            isActive = $(navMenu).hasClass(navMenuActiveClass);

            if (isActive) {
                e.preventDefault();
                tabbableElements.first()[0].focus(); // [0] gets the DOM element from the jQuery object
            }
        }
    });

    // Ensuring focus shifts back to hamburger toggle button when going back
    tabbableElements.first().keydown(function (e) {
        if (e.shiftKey && e.key === 'Tab') {
            isActive = $(navMenu).hasClass(navMenuActiveClass);

            if (
                isActive &&
                document.activeElement === tabbableElements.first()[0]
            ) {
                e.preventDefault();
                $(selector)[0].focus(); // [0] gets the DOM element from the jQuery object
            }
        }
    });

    // Ensuring focus shifts back to hamburger toggle button after last link in slide out nav menu
    tabbableElements.last().keydown(function (e) {
        if (e.key === 'Tab') {
            isActive = $(navMenu).hasClass(navMenuActiveClass);

            if (
                isActive &&
                document.activeElement === tabbableElements.last()[0]
            ) {
                e.preventDefault();
                $(selector)[0].focus(); // [0] gets the DOM element from the jQuery object
            }
        }
    });

    $(window).on('resize', () => {
        if ($(window).width() >= 1140) {
            if ($('.o-header-1__hamburger').hasClass('is-active')) {
                $('.o-header-1__hamburger').trigger('click');
            }
        }
    });
}

export function hamburgerClose() {
    $(selector).removeClass(activeClass);
    $('.js-body').removeClass(bodyActiveClass);
    $('.js-header').removeClass(headerActiveClass);
    $(navMenu).removeClass(navMenuActiveClass);
}
